// Load Bootstrap JS
import * as bootstrap from 'bootstrap'; 

// Load Styles
import '../scss/main.scss';
import initEmailAddress from "./modules/init_email_address";
import { initMenu } from "./modules/init_menu";
import { initHamburgerMenu } from "./modules/init_hamburger_menu";
import { initSwiperSlider } from "./modules/init_swiper_slider";
import { initHistory } from "./modules/init_history";
import { initScrollNavbar } from "./modules/init_scroll_navbar";
import { initSliderWithVideo } from './modules/init_slider_with_video';
import { initSearch } from "./modules/init_search";
import { initCardImageSlider } from "./modules/init_card_image_slider";
import { initMultistepForm } from "./modules/init_multistep_form";
import JobsFilter from './modules/jobs-filter';
import ApplicationForm from './modules/init_application_form';
import { initContactForm } from './modules/init_contact_form';
window.addEventListener('load',()=>{
  initSearch();
  initEmailAddress('.ks-email');
 // initMenu();
 // initHamburgerMenu();
  initSwiperSlider();
  initHistory();
  initScrollNavbar();
  initSliderWithVideo();
  initCardImageSlider();
  initMultistepForm();
  initContactForm();
  // Initialize jobs filter
  new JobsFilter();
  
  // Initialize application form
  new ApplicationForm();
})